/**
 * Action Types
 */

export const Types = {
    SELECT_MENU: 'menu/SELECT_MENU',
    DESELECT_MENU: 'menu/DESELECT_MENU'
};

/**
 * Reducer
 */

const INITIAL_STATE = 'alert';

export default function menuAtivo(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.SELECT_MENU:
            return action.payload;

        case Types.DESELECT_MENU:
            return { ...INITIAL_STATE };

        default:
            return state;
    }
}

/**
 * Action Creators
 */

export const Creators = {
    selectMenu: (payload) => ({
        type: Types.SELECT_MENU,
        payload
    }),
    deselectMenu: () => ({
        type: Types.DESELECT_MENU
    })
};
